var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:edit-outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#04245C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.875 18C8.53125 18 8.23708 17.8696 7.9925 17.6087C7.74792 17.3478 7.62542 17.0338 7.625 16.6667V8H7V6.66667H10.125V6H13.875V6.66667H17V8H16.375V16.6667C16.375 17.0333 16.2527 17.3473 16.0081 17.6087C15.7635 17.87 15.4692 18.0004 15.125 18H8.875ZM15.125 8H8.875V16.6667H15.125V8ZM10.125 15.3333H11.375V9.33333H10.125V15.3333ZM12.625 15.3333H13.875V9.33333H12.625V15.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/delete_filled.2cea6bdf64f10ec34e83506af9b0c933.svg";
export { ForwardRef as ReactComponent };